<template>
  <section class="features">
    <div class="container">
      <div class="section-title">
        <h2 class="gradient-text">Our Advantages</h2>
        <p>Committed to providing users with the highest quality products and service experience</p>
      </div>
      <div class="features-grid responsive-grid">
        <div v-for="feature in features" :key="feature.id" class="feature-card card-shadow hover-lift">
          <div class="feature-icon img-hover">{{ feature.icon }}</div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Features',
  props: {
    features: Array
  }
}
</script>

<style scoped>
.features {
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;
}

.features::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="%232c5aa0" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23dots)"/></svg>');
  opacity: 0.3;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.section-title {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title h2 {
  font-size: 3rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 300;
  position: relative;
}

.section-title h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #2c5aa0, #4a7bc8);
  border-radius: 2px;
}

.section-title p {
  font-size: 1.3rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.features-grid {
  gap: 2.5rem;
  margin-top: 3rem;
}

.feature-card {
  background: white;
  padding: 3rem 2rem;
  border-radius: 20px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(44, 90, 160, 0.1);
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2c5aa0, #4a7bc8);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(44, 90, 160, 0.15);
}

.feature-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #2c5aa0, #4a7bc8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  font-size: 2.5rem;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(44, 90, 160, 0.2);
}

.feature-card:hover .feature-icon {
  transform: scale(1.1);
  box-shadow: 0 12px 30px rgba(44, 90, 160, 0.3);
}

.feature-card h3 {
  font-size: 1.6rem;
  margin-bottom: 1rem;
  color: #333;
  font-weight: 600;
}

.feature-card p {
  color: #666;
  line-height: 1.7;
  font-size: 1rem;
}

.gradient-text {
  background: linear-gradient(45deg, #2c5aa0, #4a7bc8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 768px) {
  .features {
    padding: 4rem 1rem;
  }
  
  .section-title h2 {
    font-size: 2.5rem;
  }
  
  .section-title p {
    font-size: 1.1rem;
  }
  
  .feature-card {
    padding: 2rem 1.5rem;
  }
  
  .feature-icon {
    width: 70px;
    height: 70px;
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .section-title h2 {
    font-size: 2rem;
  }
  
  .feature-card h3 {
    font-size: 1.4rem;
  }
}
</style> 